import { type ReactNode } from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { StickyNote } from "lucide-react";
import { BuilderSection } from "./builder-section";

interface RefinementSectionProps {
  internalNotes: string;
  onInternalNotesChange: (value: string) => void;
  isReadOnly?: boolean;
  stepNumber?: number;
  children?: ReactNode;
}

export function RefinementSection({
  internalNotes,
  onInternalNotesChange,
  isReadOnly,
  stepNumber,
  children,
}: RefinementSectionProps) {
  return (
    <BuilderSection
      title="Refinement"
      description="Internal notes and metadata"
      icon={StickyNote}
      stepNumber={stepNumber}
      defaultOpen={false}
      disabled={isReadOnly}
    >
      <div className="space-y-2">
        <Label>Internal Notes</Label>
        <Textarea
          value={internalNotes}
          onChange={(e) => onInternalNotesChange(e.target.value)}
          placeholder="Add internal notes visible only to admins..."
          rows={3}
          disabled={isReadOnly}
          data-testid="input-internal-notes"
        />
        <p className="text-xs text-muted-foreground">
          These notes are only visible to administrators and will not be shown
          to users.
        </p>
      </div>
      {children}
    </BuilderSection>
  );
}
